import type { RouteRecordRaw } from 'vue-router';
import { roterPre } from '@/settings';

/**
 * 旧协作地址重定向到活动 / 艺人下的菜单地址。
 * 页面本身挂在 activity.ts、artist.ts，侧栏以 ti_eb_system_menu 为准。
 */
const collaborationRouter: RouteRecordRaw[] = [
  { path: `${roterPre}/collaboration/artist-invite/browse`, redirect: `${roterPre}/artist/browse` },
  { path: `${roterPre}/collaboration/artist-invite/edit`, redirect: `${roterPre}/artist/invite/edit` },
  { path: `${roterPre}/collaboration/artist-invite`, redirect: `${roterPre}/artist/invite` },
  { path: `${roterPre}/collaboration/market`, redirect: `${roterPre}/artist/browse` },
  { path: `${roterPre}/collaboration/place/browse`, redirect: `${roterPre}/activity/place/browse` },
  { path: `${roterPre}/collaboration/place/edit`, redirect: `${roterPre}/activity/place/collaboration/edit` },
  { path: `${roterPre}/collaboration/place`, redirect: `${roterPre}/activity/place/collaboration` },
  {
    path: `${roterPre}/collaboration/rental-market`,
    component: () => import('@/views/_expand/collaboration/rental-market/index.vue'),
  },
  { path: `${roterPre}/collaboration/rental-slot/edit`, redirect: `${roterPre}/activity/place/slot/edit` },
  { path: `${roterPre}/collaboration/rental-slot/batch`, redirect: `${roterPre}/activity/place/slot/batch` },
  { path: `${roterPre}/collaboration/rental-slot/zones`, redirect: `${roterPre}/activity/place/slot/zones` },
  { path: `${roterPre}/collaboration/rental-slot`, redirect: `${roterPre}/activity/place/slot` },
  { path: `${roterPre}/collaboration/settlement`, redirect: `${roterPre}/activity/settlement` },
  { path: `${roterPre}/collaboration/show-series/edit/:id`, redirect: (to) => `${roterPre}/activity/show-series/edit/${to.params.id}` },
  { path: `${roterPre}/collaboration/show-series`, redirect: `${roterPre}/activity/show-series` },
  { path: `${roterPre}/collaboration/show-calendar`, redirect: `${roterPre}/activity/show-calendar` },
  { path: `${roterPre}/collaboration/draft/edit`, redirect: `${roterPre}/activity/list` },
  { path: `${roterPre}/collaboration/draft`, redirect: `${roterPre}/activity/list` },
  { path: `${roterPre}/collaboration/quickActivity`, redirect: `${roterPre}/activity/list` },
];

export default collaborationRouter;
